export enum SubDirectoryEnum {
  Signatures = 'signatures',
}

export interface UploadArchiveRequest {
  file: Blob[] | Blob;
  isPublic: boolean;
  featureId?: string;
  companyId?: string;
  extension?: string;
  subdirectory?: SubDirectoryEnum;
}

export interface UploadArchiveResult {
  name: string;
  filePath: string;
}

export interface GetArchiveRequest {
  key: string;
  subdirectory?: string;
}
